<template>
	<span
		class="title-poster__free-tag"
		:class="t('WEBAPP_FREE').length > 8 ? 'fz-13' : 'fz-14'"
		@click="setBuyBoxTypeToFree"
	>
		{{ t('WEBAPP_FREE') }}
	</span>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/pinia/useUserStore';
import { MonetizationType } from '@/@types/graphql-types';

const userStore = useUserStore();

const { t } = useI18n();

const setBuyBoxTypeToFree = () => {
	if (userStore.buyboxPresentationType !== MonetizationType.Free) {
		userStore.setBuyboxPresentationType({ presentationType: MonetizationType.Free });
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rtl-support-mixins';

.title-poster__free-tag {
	border: none;
	cursor: pointer;
	position: absolute;
	@include rtl {
		transform: rotate(-45deg);
		left: -52px;
		right: auto;
	}
	top: 13px;
	right: -52px;
	z-index: 1;
	width: 160px;
	transform: rotate(45deg);
	background-color: #f7f7f8;
	padding: 8px 16px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: bold;
	color: #000;
	line-height: 14px;
	letter-spacing: 0.24px;
	&.fz-13 {
		font-size: 13px;
	}

	&.fz-14 {
		font-size: 14px;
	}
}
</style>
